var path = '/app/components/modalComponent/modalcomponent.html';
var html = "<div class=modal-header> <h3 class=modal-title id=modal-title>{{ ctrl.context.title }}</h3> </div> <div class=modal-body id=modal-body> {{ ctrl.context.body }} <ul ng-if=ctrl.context.list class=mt-2> <li ng-repeat=\"item in ctrl.context.list track by $index\">{{ item }}</li> </ul> </div> <div class=modal-footer> <button ng-if=ctrl.context.confirmBtnText class=btn ng-class=ctrl.confirmBtnClass type=button ng-click=ctrl.ok()>{{ ctrl.context.confirmBtnText }}</button> <button ng-if=ctrl.context.cancelBtnText class=\"btn btn-default\" type=button ng-click=ctrl.cancel()>{{ ctrl.context.cancelBtnText }}</button> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modalComponent/modalcomponent.html
// module id = 427
// module chunks = 0